/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type WorkspaceDetailMemberType =
  (typeof WorkspaceDetailMemberType)[keyof typeof WorkspaceDetailMemberType];

export const WorkspaceDetailMemberType = {
  UNKNOWN: 'UNKNOWN',
  MEMBER: 'MEMBER',
  OWNER: 'OWNER',
} as const;
